import { SOCIAL_SHARE_TYPES } from 'dpl/shared/constants/social';

export function getSocialShareLink(
  type,
  url = window.location.href,
  title = window.document.title
) {
  const encodedTitle = window.encodeURIComponent(title);
  const encodedUrl = window.encodeURIComponent(url);
  const encodedBody = window.encodeURIComponent(`${title}: ${url}`);

  switch (type) {
    case SOCIAL_SHARE_TYPES.FACEBOOK:
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&title=${encodedTitle}`;
    case SOCIAL_SHARE_TYPES.TWITTER:
      return `https://twitter.com/intent/tweet?text=${encodedBody}`;
    case SOCIAL_SHARE_TYPES.EMAIL:
      return `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
    default:
      return null;
  }
}
